/**
 * Terms & Conditions Content
 * Version: 1.0
 * Last Updated: March 2026
 */

export const TERMS_VERSION = "1.0";

export const TERMS_SECTIONS = [
  {
    title: "1. Service Provider",
    content:
      "These Terms and Conditions govern your use of the My Agent Report service provided by My Agent Report Ltd, a company registered in New Zealand.",
  },
  {
    title: "2. Contact Consent",
    content:
      "By using this service, you confirm that all contacts you add to the system have given their explicit consent to receive property market reports via email. You are solely responsible for obtaining and maintaining this consent. Adding contacts without their consent is a breach of these terms.",
  },
  {
    title: "3. Anti-Spam Policy",
    content:
      "Our email delivery reputation affects all users of the service. If reports you send are marked as spam or result in spam complaints, My Agent Report Ltd reserves the right to suspend or terminate your account without notice. Repeated violations may result in permanent ban from the service.",
  },
  {
    title: "4. Report Distribution",
    content:
      "Property market reports generated through this service are intended solely for the contacts listed in your account. You must not forward, redistribute, or share reports with individuals who are not registered contacts in the system. Violation of this policy may result in account termination.",
  },
  {
    title: "5. Account Security",
    content:
      "Your login credentials are personal and must not be shared with any other person. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. Notify us immediately if you suspect unauthorized access.",
  },
  {
    title: "6. Prohibited Activities",
    content:
      "You must not use automated systems, bots, or scripts to access the service. Data scraping, bulk data collection, or any form of automated data extraction is strictly prohibited. Any attempt to circumvent security measures or exploit vulnerabilities will result in immediate account termination and may be reported to authorities.",
  },
  {
    title: "7. Data Ownership",
    content:
      "All property market reports generated by this service are owned by My Agent Report Ltd. While you may use reports for their intended purpose (sharing with consented contacts), you do not acquire any intellectual property rights over the reports or their content.",
  },
  {
    title: "8. Data Retention",
    content:
      "Contact data you delete is removed from our systems immediately. Generated reports are retained for 6 months for quality assurance and troubleshooting purposes. Account data is retained in accordance with the New Zealand Privacy Act 2020.",
  },
  {
    title: "9. Third-Party Data",
    content:
      "Property market reports contain data sourced from REINZ (Real Estate Institute of New Zealand). This data is subject to REINZ's terms of use and licensing agreements. You must not use this data in any manner that violates REINZ's terms.",
  },
  {
    title: "10. Service Disclaimer",
    content:
      'This service is provided "as-is" without warranties of any kind, express or implied. My Agent Report Ltd does not guarantee the accuracy, completeness, or timeliness of property market data. We are not liable for any decisions made based on report content.',
  },
  {
    title: "11. Governing Law",
    content:
      "These Terms and Conditions are governed by and construed in accordance with the laws of New Zealand. Any disputes arising from these terms or your use of the service shall be subject to the exclusive jurisdiction of the courts of New Zealand.",
  },
  {
    title: "12. Changes to Terms",
    content:
      "My Agent Report Ltd reserves the right to modify these terms at any time. Continued use of the service after changes constitutes acceptance of the new terms. We will notify users of significant changes via email or through the service interface.",
  },
] as const;

export const ACCEPTANCE_TEXT =
  "I have read and agree to the Terms & Conditions. I confirm that all contacts I add have consented to receive property market reports.";
